import { getInvoiceFileUrl } from 'generated/api-client';
import React, { FunctionComponent, useState } from 'react';
import { Button } from 'semantic-ui-react';
import { ToastError, ToastInfo } from 'utils';

// Unique across the issuers of the company
export const pennylaneKeyOf = (
  billingIssuerId: number,
  invoiceNumber: string,
): string => `${billingIssuerId}-${invoiceNumber}`;

// An invoice or a credit note in Pennylane, unique with its issuer
type Props = {
  billingIssuerId: number;
  invoiceNumber: string;
};

export const InvoiceFileButton: FunctionComponent<Props> = ({
  billingIssuerId,
  invoiceNumber,
}) => {
  const [downloading, setDownloading] = useState(false);

  const download = async (): Promise<void> => {
    const tab = window.open('', '_blank');
    if (!tab) {
      ToastError(
        'Onglet bloqué',
        "Autorisez les fenêtres pop-up de l'admin pour ouvrir le PDF.",
      );
      return;
    }
    tab.opener = null;
    setDownloading(true);

    try {
      const { data } = await getInvoiceFileUrl({
        path: { billingIssuerId },
        query: { invoiceNumber },
        throwOnError: true,
      });

      if (data.url) {
        tab.location.replace(data.url);
      } else {
        tab.close();
        ToastInfo(
          'PDF en cours de création',
          'Pennylane crée le PDF, réessayez dans quelques minutes.',
        );
      }
    } catch (error) {
      tab.close();
      ToastError('Erreur', 'Impossible de télécharger le PDF.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      type="button"
      icon="download"
      title="Télécharger"
      loading={downloading}
      onClick={download}
    />
  );
};
